import { render, staticRenderFns } from "./appointmentDialog.vue?vue&type=template&id=279fff26&scoped=true"
import script from "./appointmentDialog.vue?vue&type=script&lang=js"
export * from "./appointmentDialog.vue?vue&type=script&lang=js"
import style0 from "./appointmentDialog.vue?vue&type=style&index=0&id=279fff26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279fff26",
  null
  
)

export default component.exports